/**
 * FeaturedVideo Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the FeaturedVideo template.
 *
 * @namespace FeaturedVideo
 */

import {register} from '../vendor/theme-scripts/theme-sections';
import parallaxHero from '../features/parallax-hero';
import {VideoPopup} from '../features/video-popup';

import {VideoBackground} from './video-background';

register('featured-video', [parallaxHero]);

if (!customElements.get('video-background')) {
  customElements.define('video-background', VideoBackground);
}

if (!customElements.get('video-popup')) {
  customElements.define('video-popup', VideoPopup);
}
